class Observer {
  constructor (fun: unknown) {
    this.fun = fun
  }

  fun: any

  // 目标对象更新时触发的回调，即收到更新通知后的回调
  update (): void {
    this.fun()
  }
}

export default Observer
